export { default as RcmScript } from './RcmScript'
